module.exports = __webpack_public_path__ + "static/cheese-bread-9b84b2fe14f929a96f9bb18fc463fe43.jpg";